import React from 'react'
import {  RouteObject } from 'react-router-dom'
import HomePage from '../pages/HomePage'
import Play from '../pages/Play'
import Setting from '../pages/Setting'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/play',
    element: <Play />
  },
  {
    path: '/setting',
    element: <Setting />
  }
]

export default routes